import styled from 'styled-components';

export const PersonalProfileWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:100%;


`,
);

export const ProfileDetailsEntryWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  padding-top:${props.theme.spacing.large.l15};
  padding-bottom:${props.theme.spacing.base};
  padding-right:${props.theme.spacing.large.l20};
  padding-left:${props.theme.spacing.large.l20};
`,
);

export const GstOuterEntryWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  padding-bottom:${props.theme.spacing.large.l20};
  padding-left:${props.theme.spacing.large.l20};
  padding-right:${props.theme.spacing.large.l20};

`,
);

export const PanOuterEntryWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    padding-bottom:${props.theme.spacing.large.l20};
  `,
);

export const NameDetailsEntryWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding-right:${props.theme.spacing.large.l25};
  position:relative;
`,
);

export const CheckinTimeWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding-right:${props.theme.spacing.large.l25};
  position:relative;

`,
);

export const GstEntryWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding-right:${props.theme.spacing.large.l25};


`,
);

export const TitleTxtWrapSpan = styled.span(
  props => `

  font-size:${props.theme.font.large.font14};
  color:${props.theme.colors.black.base};

`,
);

export const NameEnterInput = styled.input(
  props => `
    display: inline-flex;
    width:24.7rem;
    height: 3.6rem;
    border-radius: ${props.theme.misc.borderRadius.base}
    padding:${props.theme.spacing.base};
    font-size: ${props.theme.font.large.font14};
    border:${props.theme.misc.border.base} solid ${props.errorBorder ? props.theme.colors.red.base : props.theme.colors.grey.lightd7};
    margin-top:${props.theme.spacing.base};
    color: ${props.theme.colors.black.base};
    border-radius:${props.theme.misc.borderRadius.base};
    ::placeholder {
      color: ${props.theme.colors.grey.grey50};
      opacity: 1; /* Firefox */
      font-size: ${props.theme.font.large.font14};


    }

    &:focus{
      box-shadow: none;
      outline-offset: 0;
      outline: 0;
    }

  `,
);

export const NameEnterSelect = styled.select(
  props => `
      margin-top:${props.theme.spacing.base};
      width:7.1rem;
      height:3.6rem;
      background-color: ${props.theme.colors.white.base};
      border:${props.theme.misc.border.base} solid ${props.theme.colors.grey.lightd7};
      border-radius:${props.theme.misc.borderRadius.base};
      color: ${props.theme.colors.black.base};
      cursor: pointer;
  `,
);

export const AddGuestWrapDiv = styled.div(
  props => `
  width:15%;
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-end;
  align-self: center;
  padding-top: ${props.theme.spacing.base};
  pointer-events: ${props.disabled ? 'none' : ''};
`,
);

export const AddGuestLink = styled.a(
  props => `
  display:inline-flex;
  cursor: pointer;
  font-size:${props.theme.font.large.font14};
  font-weight: ${props.theme.font.fontWeight.black};
  color: ${props.disabled ? props.theme.colors.grey.lightd7 : props.theme.colors.blue.base};
  &:hover{
    color: ${props.disabled ? props.theme.colors.grey.lightd7 : props.theme.colors.blue.base};
  }
`,
);

export const MobileEnterInput = styled.input(
  props => `
    display: inline-flex;
    width:28.9rem;
    border: none;
    padding:${props.theme.spacing.base};
    font-size: ${props.theme.font.large.font14};
    border:${props.theme.misc.border.base} solid ${
    props.errorBorder ? props.theme.colors.red.base : props.theme.colors.grey.lightd7
  };
    margin-top:${props.theme.spacing.base};
    color: ${props.theme.colors.black.base};
    border-radius:${props.theme.misc.borderRadius.base};
    height:3.6rem;

    ::placeholder {
      color: ${props.theme.colors.grey.grey50};
      opacity: 1; /* Firefox */
      font-size: ${props.theme.font.large.font14};
    }
    &:focus{
      box-shadow: none;
      outline-offset: 0;
      outline: 0;
    }

  `,
);

export const MobileInputOuterWrap = styled.div(
  props => `
  display:flex;
  justify-content:center;
  align-items:center;
  margin-top: ${props.theme.spacing.base};
  border: 1px solid ${props.theme.colors.grey.lightd7};
  border-radius:${props.theme.misc.borderRadius.base};
`,
);

export const MobileNoWrapper = styled.input(
  props => `
  display: inline-flex;
  width:23.9rem;
  border: none;
  padding:${props.theme.spacing.base};
  font-size: ${props.theme.font.large.font14};
  border:${props.theme.misc.border.base} solid ${
    props.errorBorder ? props.theme.colors.red.base : 'transparent'
  };
  color: ${props.theme.colors.black.base};
  border-radius:${props.theme.misc.borderRadius.base};
  height:3.6rem;

  ::placeholder {
    color: ${props.theme.colors.grey.grey50};
    opacity: 1; /* Firefox */
    font-size: ${props.theme.font.large.font14};
  }
  &:focus{
    box-shadow: none;
    outline-offset: 0;
    outline: 0;
  }

  `,
);

export const CountryCodeWrap = styled.select(
  props => `
  background:${props.theme.colors.white.base};
  width: 8rem;
  bottom: 0;
  height: 3.6rem;
  border: none;
  cursor: pointer;
  border-radius:0.4rem 0 0 0.4rem;
  background-color: ${props.theme.colors.grey.lightef};
  &:focus{
    box-shadow: none;
    outline-offset: 0;
    outline: 0;
  }
  `,
);

export const ExpectedCheckinDropdown = styled.select(
  props => `

  margin-top:${props.theme.spacing.base};
  width: 28.9rem;
  height:3.2rem;
  background-color: ${props.theme.colors.white.base};
  border:${props.theme.misc.border.base} solid ${props.theme.colors.grey.lightd7};
  border-radius:${props.theme.misc.borderRadius.base};
  color: ${props.theme.colors.black.base};
  outline: 0;
  `,
);

export const CountryCodeText = styled.option(
  props => `

  margin-right:${props.theme.spacing.large.l15};

  `,
);

export const MobileEntryWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;

`,
);

export const MessageSentWrapSpan = styled.span(
  props => `

    color:${props.theme.colors.grey.grey50};
    font-size:${props.theme.font.base};
    padding-left:${props.theme.spacing.base};

`,
);

export const GstDetailInput = styled.input(
  props => `
    display: inline-flex;
    width:2rem;
    height:2rem;
    margin-right:${props.theme.spacing.base};
    cursor: pointer;
    margin-top:${props.theme.spacing.small.s4};
    ::placeholder {
      color: ${props.theme.colors.grey.grey50};
      opacity: 1; /* Firefox */
      font-size: ${props.theme.font.large.font14};
    }
    &:focus{
      box-shadow: none;
      outline-offset: 0;
      outline: 0;
    }
  `,
);

export const PanDetailInput = styled(GstDetailInput)(
  props => `
    width: 1.3rem;
    height: 1.3rem;
    margin-top:${props.theme.spacing.base};
  `,
);

export const MessageDiv = styled.div(
  props => `
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    padding-right:${props.theme.spacing.large.l20};
    padding-top:${props.theme.spacing.base};
    font-size:${props.theme.font.base};
    color:${props.theme.colors.grey.base};
  `,
);

export const MessageListDiv = styled(MessageDiv)(
  props => `
    display: list-item;
    margin-left: ${props.theme.spacing.large.l20};
  `,
);

export const ErrorMessageDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    padding-right:${props.theme.spacing.large.l20};
    padding-top:${props.theme.spacing.base};
    font-size:${props.theme.font.base};
    color:${props.theme.colors.red.base};
  `,
);